import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import "./style.scss";
import { initGA, logPageView } from "../../../analytics";
import { withRouter, Link, useHistory } from "react-router-dom";
// localStorage.removeItem("newNameArray");
const AdminModule = (props) => {
  const location = useLocation();
  const [LoginFormData, setLoginFormData] = useState();

  const history = useHistory();
  useEffect(() => {
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let LoginData = JSON.parse(value);
      setLoginFormData(LoginData);
    } catch (error) {}
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  return (
    <>
      {LoginFormData && LoginFormData?.role ? (
        <div className="background-dashboard">
          <Sidebar />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default AdminModule;
